import { makeECOptions, soulParse } from '../helpers/soulhelper'
import debounce from 'lodash/debounce'

export default {
  state: {
    compileError: false,
    requestUpdateJsonStatus: null,
    jsonCode: {},
  },
  getters: {
    jsonCode: ({ jsonCode }) => jsonCode,
    // 改成用worker处理makeECOptions
    // jsonCode: ({ soul }) => {
    //   const start = new Date().getTime()
    //   const res = makeECOptions(soul)
    //   console.log(new Date().getTime() - start)
    //   return res
    // },
    compileError: ({ compileError }) => compileError,
  },
  actions: {
    // 直接更新soul, 这个soul比较函数，会导致页面卡，不直接使用
    updateJsonCode ({ state, dispatch }, val) {
      dispatch('restoreSoul', val)
    },
    // 通过debounce延迟请求，解决页面卡的问题
    requestUpdateJsonCode: debounce(function ({ dispatch, commit }, val) {
      dispatch('updateJsonCode', val)
      commit('setRequestUpdateJsonStatus', null) // 结束就设置为null
    }, 300),
    // 再上面基础上，加一个标志位，解决再编辑情况下，soul解析完后生成options，json数据被突然覆盖
    sendUpdateJsonCodeRequest ({ state, dispatch, commit }, val) {
      commit('setRequestUpdateJsonStatus', new Date().getTime()) // 设置请求标志位
      dispatch('requestUpdateJsonCode', val)
    },
  },
  mutations: {
    setJsonCode (state, value) {
      if (!state.requestUpdateJsonStatus) { // 状态为空的设置值，表示不是再输入状态了
        state.jsonCode = value
      }
    },
    setRealJsonCode (state, value) {
      state.jsonCode = value
    },
    setRequestUpdateJsonStatus (state, value) {
      state.requestUpdateJsonStatus = value
    },
    setCompileError (state, val) {
      state.compileError = val
    }
  }
}
